module.exports = __webpack_public_path__ + "static/TrainingObjectiveAndIncidentChart_1-c8e2ad124eb30140d8c20de35eed2973.png";